import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Button, Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const KidsSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$local.$hpCopy' });

  return (
    <section className="base-section kids-section main-hp hp-section">
      <div className="mod-wrap">
        <Link href={t('kidsLink')} className="module fragrance kids clearfix">
          <div className="branding-hero">
            <div className="img-wrap-tall">
              <picture>
                <source
                  srcSet="/images/homepage/kidsSection/kem-kids-mob.webp"
                  media="(max-width: 768px)"
                />
                <img
                  src="/images/homepage/kidsSection/kem-kids-dsktp.webp"
                  alt="Kids"
                  width={1020}
                  height={715}
                />
              </picture>
            </div>
          </div>
          <div className="outer-wrap">
            <div className="inner-wrap">
              <div className="title">
                <div className="inner-title">
                  <h2>{t('kidsHeading')}</h2>
                  <p>{t('kidsText')}</p>
                  <Button ariaLabel={t('kidsCta')}>{t('kidsCta')}</Button>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default KidsSection;
